import React from "react";
import { Modal, ModalHeader } from "reactstrap";

const ModalComp = (props) => {
  const { modal, toggle, component, dark } = props;

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      className={`modalComp ${dark ? "modalCompDarkBg" : ""}`}
    >
      <ModalHeader toggle={toggle} />
      {component}
    </Modal>
  );
};

export { ModalComp };
